import { Common } from '../Common';
import { appConfig as $config } from '../../app.config';
import { UI } from '../UI';
import { App } from '../App';
import { User } from '../User';
import { QuickFilters, setStoredLicensorsToFilter } from './quick-filters';

import { PageSearch } from '../PageSearch';

import './scss/filter.scss';

export const SortFilter = (function () {
  let $page, $selector, $update, $uid, $requestPage, $isLicensorSelect, $quickFilterAutocomplete = {};
  let valueSeparator = '||';

  let mapping = {
    initData: () => {
      let filterdata = $storage.get('filterdata_' + $page) || {};
      let sortingpage = $storage.get('sortingpage_' + $page) || {};
      let filtersgpage = $storage.get('filterspage_' + $page) || [];

      if (filterdata.filterItems) {
        filterdata.filterItems.forEach((item) => {
          // Existed onpage filters
          let filterExist = filtersgpage.findIndex((el) => el.internalName == item.internalName);
          if (filterExist > -1) {
            // Selected CheckBox
            if (item.filterTypeName == 'CheckBoxList') {
              item.defaultValues.forEach((val) => {
                if (filtersgpage[filterExist].values.findIndex((el) => el.value == val.value) > -1) {
                  val.selected = true;
                }
              });
            }

            // Selected Radio Buttons
            if (item.filterTypeName == 'RadioButton') {
              item.defaultValues.forEach((val) => {
                if (filtersgpage[filterExist].values.findIndex((el) => el.value == val.value) > -1) {
                  val.selected = true;
                }
              });
            }

            // Selected Tree CheckBox
            if (item.filterTypeName == 'CheckBoxTreeList') {
              let allitems = true;
              item.defaultValues.forEach((val) => {
                if (filtersgpage[filterExist].values.findIndex((el) => el.value == val.value) > -1) {
                  val.selected = true;
                } else {
                  allitems = false;
                }
              });
              if (allitems) {
                item.allitems = true;
              }
            }

            // Selected Date
            if (item.filterTypeName == 'Date') {
              let values = filtersgpage[filterExist].values[0].value.split(valueSeparator);
              item.value = values[0] + ' - ' + values[1];
            }

            // Selected Numeric
            if (item.filterTypeName == 'NumericRange') {
              let values = filtersgpage[filterExist].values[0].value.split(valueSeparator);
              item.value = values[0] + ' - ' + values[1];
            }
          }

          if (item.systemDefaultChecked) {
            if (filterExist > -1) {
              filtersgpage.splice(filterExist, 1);
            }

            let systemDefault = {
              internalName: item.internalName,
              displayName: item.displayName,
              filterTypeName: item.filterTypeName,
              values: []
            };
            item.defaultValues.forEach((val) => {
              val.selected = true;
              systemDefault.values.push({
                name: val.title,
                value: val.value
              });
            });
            filtersgpage = [...filtersgpage, ...[systemDefault]];
            $storage.set('filterspage_' + $page, filtersgpage);
          }

          // Filter group local search
          if (
            item.defaultValues &&
            item.defaultValues.length &&
            item.defaultValues.length > 9 &&
            !item.isAutoComplete
          ) {
            item.groupSearch = true;
          }
        });
      } else {
        filterdata.filterItems = [];
      }
      return {
        uid: $uid,
        requestPage: $page,
        filters: filterdata.filterItems,
        sortings: filterdata.sortItems,
        sortingpage: sortingpage,
        filtersgpage: filtersgpage,
        $lang: $lang
      };
    },
    filterGroupedData: (data) => {
      let groups = [];
      data.forEach((item) => {
        let itemExist = groups.findIndex((el) => el.groupDisplayName == item.groupDisplayName);
        if (itemExist > -1) {
          groups[itemExist].filters.push(item);
        } else {
          groups.push({
            groupDisplayName: item.groupDisplayName,
            internalName: item.internalName,
            filters: [item]
          });
        }
      });
      return groups;
    },
    filterdata: () => {},
    filters: (data) => {
      return $.map(data, function (item) {
        return item.displayName;
      });
    },
    sortings: (data) => {
      return $.map(data, function (item) {
        return item.displayName;
      });
    },
    prepare: (data) => {
      if (data && data.sortItems && data.sortItems.length) {
        data.sortItems.forEach((item) => {
          item.value = item.sortColumn + ':' + item.sortDir;
        });
      }
      return data;
    },
    querySorting: (data) => {
      return data ? [data] : [];
    },
    queryFilters: (data, prefilledFilters) => {
      if (!data) return [];
      let newData = [];
      data.forEach((group) => {
        let values;
        if (
          group.filterTypeName === 'MoneyRange' ||
          group.filterTypeName === 'Date' ||
          group.filterTypeName === 'NumericRange'
        ) {
          values = group.values[0].value ? group.values[0].value.split(valueSeparator) : false;
        } else {
          values = group.values.map((val) => val.value);
        }
        if (values) {
          newData.push({
            internalName: group.internalName,
            values: values
          });
        }
      });

      prefilledFilters?.forEach(pf => {
        if (!newData.find(d => d.internalName === pf.internalName)) {
          newData.push(pf);
        }
      });

      return newData;
    },
    autocomplete: (data, internalName) => {
      let filtersgpage = $storage.get('filterspage_' + $page) || [];

      const selectedFilter = filtersgpage.find((f) => f.internalName === internalName);

      return (data || []).map(d => {
        const isValueSelected = (selectedFilter?.values || []).some(v => v.value === d.value);

        return { ...d, checked: isValueSelected};
      });
    }
  };

  let init = ({
    selector = false,
    update = false,
    pagename = false,
    requestPage = '',
    filtersonly = false,
    submitprops = {},
    filters = false,
    isLicensorSelect = false,
  } = {}) => {
    $uid = Common.uniqID();

    $('body').removeClass('backside-filter-open');

    // For Old filters pages
    if (!update) {
      PageSearch.init({ filters: filters, selector: selector, submitprops: submitprops, pageName: pagename });
      return;
    }

    if (!selector) return;

    $selector = selector;
    $isLicensorSelect = isLicensorSelect;
    $page = pagename ? pagename : document.location.pathname.split('/')[1] || $config.default.page;
    $page = $page.toLowerCase();
    $update = update;
    $requestPage = requestPage;

    let data = mapping.initData();

    data.groups = mapping.filterGroupedData(data.filters);

    let template = require(`./tmpl/sort-filter.hbs`);
    $(selector).empty().html(template(data));

    App.pageData('filtersgpage', data.filtersgpage);

    if (!filtersonly) {
      sortingInit();
    }

    filtersInit();
  };

  let updateCheckBoxLists = () => {
    let data = mapping.initData();

    const changedFilters = (data?.filters || [])
      .filter(f => f.filterTypeName === 'CheckBoxList')
      .filter(f => {
        const existingFilters = $(
          `.side-filter-box #backside-filter-collapse-${f.internalName} .kt-checkbox:not(.bind-select-group)`
        );

        return existingFilters.length !== f.defaultValues?.length;
      });

    const template = require(`./tmpl/partial/CheckBoxList.hbs`);
    changedFilters.forEach((f) => $(`#backside-filter-collapse-${f.internalName}`).empty().html(template(f)));

    KTApp.initScroll();

    $('body')
      .off('change', checkBoxHandler)
      .on('change', '.side-filter-box .kt-checkbox:not(.bind-select-group)', checkBoxHandler);

    updateQuickFilters();
  };

  let updateQuickFilters = () => {
    quickFilters.init();
  };

  let sortingInit = () => {
    $('select[name="sorting"]', $($selector))
      .select2({ width: 'auto' })
      .on('change', () => {
        let value = $('select[name="sorting"]', $($selector)).val();
        if (!value) return;
        let sorting = {
          value: value,
          sortColumn: value.split(':')[0],
          sortDir: value.split(':')[1] * 1
        };
        $storage.set('sortingpage_' + $page, sorting);
        targetUpdate();
      });
  };

  let filtersInit = () => {
    $($selector).addClass('filters-complete');

    dataBinder.dataBind($('.side-filter-box', $($selector))[0], {});

    KTApp.initScroll();

    // Autocomplete
    $('.side-filter-box .js-autocomplete')
      .off()
      .smartkeyup(function (e) {
        filterAutocomplete($(e.currentTarget));
      });
    $('.side-filter-box .js-autocomplete-reset')
      .off()
      .on('click', function (e) {
        filterAutocompleteClearResults($(e.currentTarget), true, true);
      });

    $('body')
      .off('change', checkBoxHandler)
      .off('change', radioBtnHandler)
      .off('change', groupCheckBoxHandler)
      .on('change', '.side-filter-box .kt-radio', radioBtnHandler)
      .on('change', '.side-filter-box .kt-checkbox:not(.bind-select-group)', checkBoxHandler)
      .on('change', '.side-filter-box .bind-select-group', groupCheckBoxHandler);

    $('body')
      .off('click', removeHandler)
      .off('click', filtersReset)
      .on('click', '.bbw-filter-item .remove', removeHandler)
      .on('click', '.bbw-filter-items .js-action-clearall-strip-btn', filtersReset)
      .on('click', '.side-filter-box .js-filters-clear', filtersReset);

    // Quick filters on Orders Page
    quickFilters.init();

    moneyRangeInit();

    dateRangeInit();

    numericRangeInit();
  };

  let targetUpdate = () => {
    paginationReset();
    QuickFilters.update($page);
    $update();
  };

  let radioBtnHandler = function (e) {
    if (!$(e.target).closest('.side-filter-box').length && !$(e.target).closest('.quick-filters').length) {
      return;
    }
    let name = $.trim($(this).text());
    let input = $('input[type="radio"]', $(this));
    let value = input.data('value');
    let encodedValue = value && encodeURI(value);
    let group = input.data('group');

    $(`.bbw-filter-item[data-group="${group}"]`).remove();

    if (input.is(':checked')) {
      if (!$(`.bbw-filter-item[data-value="${encodedValue}"][data-group="${group}"]`).length) {
        $(`.bbw-filter-items-${$uid}`).append(filterItemTag(encodedValue, 'RadioButton', group, name));
      }
    }

    filtersUpdate(group, {
      name: name,
      value: value
    });
  };

  let checkBoxHandler = function (e) {
    if (!$(e.target).closest('.side-filter-box').length && !$(e.target).closest('.quick-filters').length) {
      return;
    }
    let name = $.trim($(e.currentTarget).text());
    let input = $('input[type="checkbox"]', $(e.currentTarget));
    let value = input.data('value');
    let encodedValue = value && encodeURI(value);
    let group = input.data('group');

    if (input.is(':checked')) {
      if (!$(`.bbw-filter-item[data-value="${encodedValue}"][data-group="${group}"]`).length) {
        $(`.bbw-filter-items-${$uid}`).append(filterItemTag(encodedValue, 'CheckBoxList', group, name));
      }
    } else {
      $(`.bbw-filter-item[data-value="${encodedValue}"][data-group="${group}"]`).remove();
    }

    filtersUpdate(group, {
      name: name,
      value: value
    });
  };

  let checkBoxHandlerQuickFilter = function (e) {
    checkBoxHandler(e);

    $quickFilterAutocomplete.enabled = true;
  }

  let groupCheckBoxHandler = function (e) {
    if (!$(e.target).closest('.side-filter-box').length) {
      return;
    }
    let input = $('input[type="checkbox"]', $(this));
    let group = input.data('group');
    if (input.is(':checked')) {
      let values = [];
      $(`.card-body input[type="checkbox"][data-group="${group}"]`).each(function () {
        let name = $.trim($(this).closest('label').text());
        let value = $(this).data('value');
        $(`.bbw-filter-items-${$uid}`).append(filterItemTag(value, 'CheckBoxTreeList', group, name));
        values.push({
          name: name,
          value: value
        });
      });
      filtersUpdate(group, values);
    } else {
      $(`.bbw-filter-item[data-group="${group}"]`).remove();
      filtersUpdate(group, 'reset');
    }
  };

  /**  - DATE RANGE  -- */
  let dateRangeOptions = (group) => {
    if (!group) return;
    return {
      target: $(`.js-filter-daterange[data-internalname="${group}"]`),
      startEmpty: true,
      minDate: moment().subtract(2, 'years'),
      maxDate: moment(),
      inline: true,
      showHeader: false,
      calendarCount: 1,
      showFooter: false,
      oneCalendarWidth: 260,
      format: $config.appFullDateFormat,
      monthSwitcherFormat: 'MMM',
      startOnMonday: true,
      locale: 'en',
      onafterselect: function (calentim, startDate, endDate) {
        dateRangeUpdate(group, startDate, endDate);
      }
    };
  };

  let dateRangeInit = () => {
    if (!$('.js-filter-daterange-calendar').length) return;

    $('.js-filter-daterange-calendar').each(function () {
      let group = $(this).data('group');
      $(this).calentim(dateRangeOptions(group));
    });
  };

  let dateRangeUpdate = (group, startDate, endDate) => {
    if (!group) return;
    $(`.bbw-filter-items-${$uid} .bbw-filter-item[data-group="${group}"]`, $($selector)).remove();
    let name = startDate.format($config.appFullDateFormat) + ' - ' + endDate.format($config.appFullDateFormat);
    let val = startDate.format($config.appFullDateFormat) + valueSeparator + endDate.format($config.appFullDateFormat);
    $(`.bbw-filter-items-${$uid}`).append(filterItemTag(val, 'Date', group, name));
    filtersUpdate(group, { name: name, value: val });
  };

  let dateRangeReset = ({ group = false, noinit = false } = {}) => {
    if (!group) {
      $('.js-filter-daterange-calendar').each(function () {
        let group = $(this).data('group');
        let calent = $(`.js-filter-daterange-calendar[data-group="${group}"]`).data('calentim');
        calent.destroy();
        if (!noinit) {
          $(`.js-filter-daterange[data-internalname="${group}"]`).val('');
          $(`.js-filter-daterange-calendar[data-group="${group}"]`).calentim(dateRangeOptions(group));
        }
      });
    } else {
      let calent = $(`.js-filter-daterange-calendar[data-group="${group}"]`).data('calentim');
      if (!calent) return;
      calent.destroy();
      if (noinit) return;
      $(`.js-filter-daterange[data-internalname="${group}"]`).val('');
      $(`.js-filter-daterange-calendar[data-group="${group}"]`).calentim(dateRangeOptions(group));
    }
  };

  /**  - NUMERIC RANGE  -- */
  let numericRangeInit = () => {
    if (!$('.js-numericRange-div').length) return;

    $('.js-numericRange-div').each(function () {
      let sliderDiv = $(this);
      let group = sliderDiv.data('internalname');
      let uid = sliderDiv.data('uid');

      let dataStart = sliderDiv.data('start') || '0';
      let dataEnd = sliderDiv.data('end') || $config.filter.moneyRange[1];
      let defStart = dataStart;
      let defEnd = dataEnd;

      let slider = sliderDiv[0];

      let filtersgpage = $storage.get('filterspage_' + $page) || [];
      let filterExist = filtersgpage.findIndex((el) => el.internalName == group);
      if (filterExist > -1) {
        if (filtersgpage[filterExist].values[0].value) {
          defStart = filtersgpage[filterExist].values[0].value.split(valueSeparator)[0] * 1;
          defEnd = filtersgpage[filterExist].values[0].value.split(valueSeparator)[1] * 1;
        }
      }

      noUiSlider.create(slider, {
        start: [defStart * 1, defEnd * 1],
        step: 5,
        connect: true,
        tooltips: true,
        format: wNumb({
          decimals: 0
        }),
        range: {
          min: [dataStart * 1],
          max: [dataEnd * 1]
        },
        pips: {
          mode: 'count',
          values: 4,
          density: 4
        }
      });

      slider.noUiSlider.on('change', function (values, handle) {
        numericRangeUpdate(group, values);
      });
    });
  };

  let numericRangeUpdate = (group, values) => {
    if (!group) return false;
    // Clear
    numericRangeReset(group, true);

    let elem = $(`.js-numericRange-div[data-internalname="${group}"]`);
    let defStart = elem.data('start') || $config.filter.moneyRange[0];
    let defEnd = elem.data('end') || $config.filter.moneyRange[1];

    // If not default range
    if (values[0] * 1 != defStart * 1 || values[1] * 1 != defEnd * 1) {
      let name = `${values[0]} - ${values[1]}`;
      let val = values[0] + valueSeparator + values[1];
      $(`.bbw-filter-items-${$uid}`).append(filterItemTag(val, 'NumericRange', group, name));
      filtersUpdate(group, { name: name, value: val });
    }
    return false;
  };

  let numericRangeReset = (group = false, local = false) => {
    if (!group) {
      $(`.js-numericRange-div`).each(function () {
        let sliderDiv = $(this);
        let group = sliderDiv.data('internalname');
        let uid = sliderDiv.data('uid');
        let defStart = sliderDiv.data('start') || $config.filter.moneyRange[0];
        let defEnd = sliderDiv.data('end') || $config.filter.moneyRange[1];
        let slider = sliderDiv[0];
        slider.noUiSlider.set([defStart * 1, defEnd * 1]);
      });
      return;
    }

    let sliderDiv = $(`.js-numericRange-div[data-internalname="${group}"]`);
    let defStart = sliderDiv.data('start') || $config.filter.moneyRange[0];
    let defEnd = sliderDiv.data('end') || $config.filter.moneyRange[1];
    let slider = sliderDiv[0];

    if (!local) {
      slider.noUiSlider.set([defStart * 1, defEnd * 1]);
    } else {
      $(`.bbw-filter-item[data-group="${group}"]`).remove();
      filtersUpdate(group, 'reset');
    }
  };

  /**  - MONEY RANGE  -- */
  let moneyRangeInit = () => {
    if (!$('.js-moneyRange-div').length) return;

    $('.js-moneyRange-div').each(function () {
      let sliderDiv = $(this);
      let group = sliderDiv.data('internalname');
      let uid = sliderDiv.data('uid');

      let start = $config.filter.moneyRange;
      let slider = sliderDiv[0];

      let filtersgpage = $storage.get('filterspage_' + $page) || [];
      let filterExist = filtersgpage.findIndex((el) => el.internalName == group);
      if (filterExist > -1) {
        start = filtersgpage[filterExist].values[0].value
          ? filtersgpage[filterExist].values[0].value.split(valueSeparator)
          : start;
      }

      noUiSlider.create(slider, {
        start: start,
        step: 5,
        connect: true,
        tooltips: [wNumb({ decimals: 2, prefix: '$' }), wNumb({ decimals: 2, prefix: '$' })],
        range: {
          min: [$config.filter.moneyRange[0]],
          max: [$config.filter.moneyRange[1]]
        },
        pips: {
          mode: 'count',
          values: 4,
          density: 3,
          format: wNumb({
            decimals: 2,
            prefix: '$'
          })
        }
      });

      slider.noUiSlider.on('change', function (values, handle) {
        moneyRangeUpdate(group, values);
      });
    });
  };

  let moneyRangeUpdate = (group, values) => {
    if (!group) return false;
    // Clear
    moneyRangeReset(group, true);

    // If not default range
    if (values[0] * 1 != $config.filter.moneyRange[0] || values[1] * 1 != $config.filter.moneyRange[1]) {
      let name = `$${values[0]} - $${values[1]}`;
      let val = values[0] + valueSeparator + values[1];
      $(`.bbw-filter-items-${$uid}`).append(filterItemTag(val, 'MoneyRange', group, name));
      filtersUpdate(group, { name: name, value: val });
    }
    return false;
  };

  let moneyRangeReset = (group = false, local = false) => {
    if (!group) {
      $(`.js-moneyRange-div`).each(function () {
        let sliderDiv = $(this);
        let group = sliderDiv.data('internalname');
        let uid = sliderDiv.data('uid');
        let slider = sliderDiv[0];
        slider.noUiSlider.set($config.filter.moneyRange);
      });
      return;
    }

    let sliderDiv = $(`.js-moneyRange-div[data-internalname="${group}"]`);
    let slider = sliderDiv[0];

    if (!local) {
      slider.noUiSlider.set($config.filter.moneyRange);
    } else {
      $(`.bbw-filter-item[data-group="${group}"]`).remove();
      filtersUpdate(group, 'reset');
    }
  };

  let removeHandler = function (e) {
    let parent = $(this).parent('.bbw-filter-item');
    let name = parent.text();
    let value = decodeURI(parent.data('value') || '');
    let group = parent.data('group');
    let type = parent.data('type');

    if (type == 'Date') {
      dateRangeReset({ group: group });
    } else if (type == 'MoneyRange') {
      moneyRangeReset(group);
    } else if (type == 'NumericRange') {
      numericRangeReset(group);
    } else if (type == 'RadioButton') {
      $(`.side-filter-box input[type="radio"][data-value="${value}"][data-group="${group}"]`).prop('checked', false);
    } else {
      $(`.side-filter-box input[type="checkbox"][data-value="${value}"][data-group="${group}"]`).prop('checked', false);
    }

    filtersUpdate(group, {
      name: name,
      value: value
    });
    parent.remove();
  };

  let filterItemTag = (value, type, group, name) => {
    return `<div data-value="${value}" data-type="${type}" data-group="${group}" class="bbw-filter-item">${name}<b class="remove"></b></div> `;
  };

  let filtersUpdate = (group, val) => {
    let filterdata = $storage.get('filterdata_' + $page) || {};
    let filterspage = $storage.get('filterspage_' + $page) || [];

    if (group == 'reset') {
      // Reset All filters
      if (filterspage.length) {
        $storage.remove('filterspage_' + $page);
        setClearAllBtn([]);
        targetUpdate();
      }
      return;
    }

    if (Array.isArray(val)) {
      let groupdata = filterdata.filterItems.find((f) => f.internalName == group);
      filterspage.push({
        internalName: group,
        displayName: groupdata.displayName,
        filterTypeName: groupdata.filterTypeName,
        values: val
      });
      $storage.set('filterspage_' + $page, filterspage);
      setClearAllBtn(filterspage);
      targetUpdate();
      return;
    }

    if (val !== 'reset' && (!val.name || val.value === undefined)) {
      return;
    }

    let groupdata = filterdata.filterItems.find((f) => f.internalName == group);

    let groupExist = filterspage.findIndex((el) => el.internalName == group);

    if (groupExist > -1) {
      if (val == 'reset') {
        // Reset Group filters
        filterspage.splice(groupExist, 1);
        $storage.set('filterspage_' + $page, filterspage);

        setClearAllBtn(filterspage);
        // Reload page content
        targetUpdate();

        // Quick filters
        quickFilters.updateMultiCheckboxes(group);
        return;
      }

      let valExist = filterspage[groupExist].values.findIndex((el) => el.value == val.value);

      if (valExist > -1) {
        filterspage[groupExist].values.splice(valExist, 1);
        if (!filterspage[groupExist].values.length) {
          filterspage.splice(groupExist, 1);
        }
      } else {
        if (
          filterspage[groupExist].filterTypeName == 'MoneyRange' ||
          filterspage[groupExist].filterTypeName == 'NumericRange' ||
          filterspage[groupExist].filterTypeName == 'Date' ||
          filterspage[groupExist].filterTypeName == 'RadioButton'
        ) {
          filterspage[groupExist].values = [{ name: val.name, value: val.value }];
        } else {
          filterspage[groupExist].values.push({ name: val.name, value: val.value });
        }
      }
    } else {
      if (val == 'reset') {
        // Reset Group filters
        return;
      }

      filterspage.push({
        internalName: group,
        displayName: groupdata.displayName,
        filterTypeName: groupdata.filterTypeName,
        values: [
          {
            name: val.name,
            value: val.value
          }
        ]
      });
    }

    if (filterspage.length) $storage.set('filterspage_' + $page, filterspage);
    else $storage.remove('filterspage_' + $page);

    setClearAllBtn(filterspage);

    // Reload page content
    targetUpdate();

    // Quick filters
    quickFilters.updateMultiCheckboxes(group);
  };

  let filtersReset = (e) => {
    let uid = $(e.target).data('uid');
    let group = $(e.target).data('group');

    if (group) {
      let input = $(`.side-filter-box input[name="${group}"][data-internalname="${group}"]`);
      // AutoComplete
      if (input.length && input.hasClass('js-autocomplete')) {
        filterAutocompleteClearResults(input, true);

        // DateRange
      } else if (input.length && input.hasClass('js-filter-daterange')) {
        dateRangeReset({ group: group });

        // DateRange
      } else if (input.length && input.hasClass('js-moneyRange-input')) {
        moneyRangeReset(group);

        // NumericRange
      } else if (input.length && input.hasClass('js-numericRange-input')) {
        numericRangeReset(group);

        // CheckBox or Radio
      } else {
        $(`.side-filter-box input[type="radio"][data-group="${group}"]:checked`).prop('checked', false);
        $(`.side-filter-box input[type="checkbox"][data-group="${group}"]:checked`).prop('checked', false);
      }

      // Group checkAll CheckBox
      $(`input[type="checkbox"].select-group-${group}-${uid}`).prop('checked', false);

      $(`.side-filter-box input[type="checkbox"][data-group="${group}"]:checked`).prop('checked', false);

      $(`.bbw-filter-items-${$uid} .bbw-filter-item[data-group="${group}"]`).remove();
      filtersUpdate(group, 'reset');
    } else {
      // AutoComplete Reset
      $('.side-filter-box .js-autocomplete').each(function () {
        filterAutocompleteClearResults($(this), true);
      });

      // DateRange Reset
      dateRangeReset();

      // RadioButtons Reset
      $(`.side-filter-box input[type="radio"]:checked`).prop('checked', false);

      // CheckBox Reset
      $(`.side-filter-box input[type="checkbox"]:checked`).prop('checked', false);

      // Multi CheckBox Reset
      $('.quick-filters-select').val([]).trigger('change');
      quickFilters.initMultiCheckboxes();

      // MoneyRange Reset
      if ($('.side-filter-box .js-moneyRange-div').length) {
        moneyRangeReset();
      }

      // NumericRange Reset
      if ($('.side-filter-box .js-numericRange-div').length) {
        numericRangeReset();
      }

      // Group checkAll CheckBox
      $(`input[type="checkbox"].select-group-${uid}`).prop('checked', false);

      $(`.bbw-filter-items-${$uid} .bbw-filter-item`).remove();
      filtersUpdate('reset');
    }
  };

  let setClearAllBtn = (filterspage) => {
    let parent = $('.bbw-filter-items-' + $uid);
    $('.js-action-clearall-strip-btn', parent).remove();
    $(`.js-action-fiters-btn[data-uid="${$uid}"]`).removeClass('active');
    if (filterspage.length) {
      parent.append(
        $(`<button type="button" class="js-action-clearall-strip-btn btn btn-xs btn-link ml-2"/>`)
          .text($lang.filters.ClearAll)
          .data('uid', $uid)
          .on('click', filtersReset)
      );
      $(`.js-action-fiters-btn[data-uid="${$uid}"]`).addClass('active');
    }

    App.pageData('filtersgpage', filterspage || []);
  };

  /*
   **  - Autocomplete methods
   */

  let filterAutocomplete = (el, isQuickFilters) => {
    let elParent = el.closest('.form-group');
    let originalElVal = el.val();
    let elVal = originalElVal.replace(/\s+/g, ' ').trim();

    elParent.toggleClass('searching', elVal != '');

    if (elVal.length < 3) {
      filterAutocompleteClearResults(el);
      return;
    }

    filterAutocompleteLoader(el);

    let internalName = el.data('internalname');
    //let routePage = requestPageName(el);
    let routePage = el.data('requestpage');
    let requestPage = $requestPage || el.data('requestpage').toLowerCase();
    let uid = el.data('uid');
    let resultDiv = $(`#card_${internalName}_${uid}`);

    let query = {
      InternalName: internalName,
      SearchValue: elVal,
      RequestPage: requestPage,
      LicensorsId: $isLicensorSelect ? User.licensorsId() : []
    };
    App.ajaxAbortAll();
    $.when(App.ajaxData(`${routePage}/filter`, query)).done((res) => {
      let data = {
        items: mapping.autocomplete(res.data, internalName),
        internalName: internalName
      };
      let tmpl = require('./tmpl/partial/autocomplete-row.hbs');
      resultDiv.empty().html(tmpl(data));

      // Quick filters with dropdown
      // Update dropdown scroller
      quickFilters.update(resultDiv, data);

      filterAutocompleteLoader(el, true);

      if (el.val() === originalElVal) {
        el.val(elVal);
      }

      if (!isQuickFilters) {
        return;
      }

      $quickFilterAutocomplete = {
        enabled: true,
        id: resultDiv.attr('id'),
        elName: el.attr('name'),
        data,
        internalName,
        elVal
      };
    });
  };

  let filterAutocompleteClearResults = (el, reset = false, focus = false) => {
    let internalName = el.data('internalname');
    let uid = el.data('uid');
    let resultDiv = $(`#card_${internalName}_${uid}`);
    resultDiv
      .empty()
      .html(`<p class="text-center text-muted font-weight-light">${$lang.filters.Typetosearch}</p>`)
      .removeClass('show');
    if (reset) {
      let elParent = el.closest('.form-group');
      elParent.removeClass('searching');
      $('input', elParent).val('');
      if (focus) {
        $('input', elParent).focus();
      }
    }
  };

  let filterAutocompleteLoader = (el, stop = false) => {
    let elParent = el.closest('.form-group');
    let internalName = el.data('internalname');
    let uid = el.data('uid');
    if (!stop) {
      elParent.addClass('loading');
      UI.block(`#card_${internalName}_${uid}`);
    } else {
      elParent.removeClass('loading');
      UI.unblock(`#card_${internalName}_${uid}`);
    }
  };

  /*
   **  - Public methods
   */
  let isInit = (selector) => {
    return $(selector).hasClass('filters-complete');
  };

  let clear = (page = false) => {
    if (!page) return;
    $storage.remove('filterspage_' + page.toLowerCase());
    $storage.remove('sortingpage_' + page.toLowerCase());
  };

  let destroy = () => {
    dateRangeReset({ group: false, noinit: true });
    if ($('.js-moneyRange-div').length && $('.js-moneyRange-div')[0].noUiSlider) {
      $('.js-moneyRange-div')[0].noUiSlider.destroy();
    }
    $($selector).empty();
  };

  let setFilters = (page, filterspage = false) => {
    if (!page) {
      return;
    }

    if (!filterspage) {
      if ($storage.isSet('filterspage_' + page.toLowerCase())) {
        $storage.remove('filterspage_' + page.toLowerCase());
        return;
      }
    }
    $storage.set('filterspage_' + page.toLowerCase(), filterspage);
  };

  let getFilters = (page) => {
    if (!page) {
      return false;
    }

    return $storage.isSet('filterspage_' + page.toLowerCase()) ? $storage.get('filterspage_' + page.toLowerCase()) : false;
  };

  let setSorting = (page, sorting = false) => {
    if (!page) {
      return;
    }

    if (!sorting) {
      if ($storage.isSet('sortingpage_' + page.toLowerCase())) {
        $storage.remove('sortingpage_' + page.toLowerCase());
        return;
      }
    }

    $storage.set('sortingpage_' + page.toLowerCase(), sorting);
  };

  let getSorting = (page) => {
    if (!page) {
      return false;
    }

    return $storage.isSet('sortingpage_' + page.toLowerCase()) ? $storage.get('sortingpage_' + page.toLowerCase()) : false;
  };

  let cache = (page, filterspage) => {
    if (!page) {
      return;
    }

    $storage.set('filterscache_' + page.toLowerCase(), filterspage);
  };

  let fromCache = (page) => {
    if (!page) {
      return false;
    }

    if ($storage.isSet('filterscache_' + page.toLowerCase())) {
      let out = $storage.get('filterscache_' + page.toLowerCase());
      $storage.remove('filterscache_' + page.toLowerCase());
      return out;
    }

    return false;
  };

  let paginationReset = () => {
    let lastRouteResolved = document.location.pathname;
    let page = lastRouteResolved.split('/')[1] || $config.routing.startpage;
    $storage.set('pagepage_' + page, '1');

    if (document.location.search.includes('page=')) {
      history.replaceState({}, '', lastRouteResolved);
    }
    //$router.setQuery('');
  };

  let prepare = (data, page = false) => {
    if (!page) {
      page = data.requestPage
        ? data.requestPage
        : document.location.pathname.split('/')[1]
        ? document.location.pathname.split('/')[1]
        : $config.routing.startpage;
    }
    $storage.set('filterdata_' + page.toLowerCase(), mapping.prepare(data));
  };

  let prepareQuery = (data = {}) => {
    let url = document.location.pathname.split('/');
    if (!url || (url[2] && !data.requestPage)) return data;

    let pagename = data.requestPage
      ? data.requestPage
      : document.location.pathname.split('/')[1]
      ? document.location.pathname.split('/')[1]
      : $config.routing.startpage;
    pagename = pagename.toLowerCase();

    let filterspage = $requestPage ? $page : pagename;

    let sorting = $storage.isSet('sortingpage_' + filterspage) ? $storage.get('sortingpage_' + filterspage) : false;
    let filters = setStoredLicensorsToFilter(filterspage);

    let pagePage = data.page
      ? data.page
      : $storage.isSet('pagepage_' + pagename)
      ? $storage.get('pagepage_' + pagename)
      : Common.gup('page')
      ? Common.gup('page')
      : 1;

    if (sorting) delete sorting['value'];

    return {
      ...data,
      page: pagePage,
      pageLimit: $config.paging.pagelimit[pagename] || $config.paging.pagelimit.default,
      filterItems: mapping.queryFilters(filters, data.filterItems),
      sortItems: mapping.querySorting(sorting),
      requestPage: pagename,
    };
  };

  const quickFilters = {
    init: () => {
      // Quick filters on Orders Page
      const $quickFilters = $('.quick-filters');
      if ($quickFilters.length) {
        $quickFilters.removeClass('d-none');

        // Autocomplete
        $('.js-autocomplete', $quickFilters)
          .off()
          .smartkeyup(function (e) {
            filterAutocomplete($(e.currentTarget), true);
          });
        $('.js-autocomplete-reset', $quickFilters)
          .off()
          .on('click', function (e) {
            filterAutocompleteClearResults($(e.currentTarget), true, true);
          });

        // Multi CheckBox
        quickFilters.initMultiCheckboxes();

        const filtersgpage = App.pageData('filtersgpage');
        (filtersgpage || []).forEach((f) => {
          if (f.filterTypeName === 'CheckBoxList') {
            $(`.quick-filters-select[data-group="${f.internalName}"]`).val(f.values.map((v) => v.value)).trigger('change');
          }
        });

        $('body')
          .off('change', checkBoxHandlerQuickFilter)
          .on('click', (e) => {
            let dropdown = $('.quick-filters .dropdown-menu.show');
            let parent = dropdown.closest('.filter-search-group');
            if (!dropdown.length) return;
            if (!$(e.target).closest(parent).length) {
              filterAutocompleteClearResults($('input', parent), true);
            }
          })
          .on('change', '.quick-filters .kt-checkbox', checkBoxHandlerQuickFilter);

        if ($quickFilterAutocomplete.enabled) {
          let { id, data, internalName, elName, elVal } = $quickFilterAutocomplete;

          let resultDiv = $(`.quick-filters #${id}`);
          let tmpl = require('./tmpl/partial/autocomplete-row.hbs');

          data.items = mapping.autocomplete(data.items, internalName);

          resultDiv.empty().html(tmpl(data)).addClass('show');
          quickFilters.update(resultDiv, data);

          $(`.quick-filters [name=${elName}]`).val(elVal);

          $quickFilterAutocomplete.enabled = false;
        }
      }
    },
    update: (resultDiv, data) => {
      // Update dropdown scroller
      if (resultDiv.hasClass('dropdown-menu')) {
        let itemsHeight = data.items.length * 26;
        let height = itemsHeight === 0 ? 20 : itemsHeight < 200 ? itemsHeight : 200;

        resultDiv.css({ height: `${height + 16}px` }).addClass('show');

        let scroller = KTUtil.data(resultDiv[0]).get('ps');
        if (scroller) {
          scroller.update();
        }
      }
    },
    initMultiCheckboxes: () => {
      const quickFilterSelectHandler = (e) => {
        const el = $(e.currentTarget);
        const sideFilterWrapper = $(`.side-filter-box-${$uid}`);
        const value = $(e.target).val();

        let group = el.data('group');

        const checkedElements = Array.from($(`input[type="checkbox"][data-group="${group}"]:checked`, sideFilterWrapper));
        const notCheckedElements = Array.from($(`input[type="checkbox"][data-group="${group}"]:not(:checked)`, sideFilterWrapper));

        if (value == '' || !Array.isArray(value)) {
          checkedElements.forEach(el => $(el).prop('checked', false).trigger('change'));
          return;
        }

        checkedElements.forEach(el => {
          const elValue = el.getAttribute('data-value');

          if (!value.includes(elValue)) {
            $(el).prop('checked', false).trigger('change');
          }
        });

        notCheckedElements.forEach(el => {
          const elValue = el.getAttribute('data-value');

          if (value.includes(elValue)) {
            $(el).prop('checked', true).trigger('change');
          }
        });
      };

      const multiCheckboxItem = (opt) => {
        return $(
          `<label class="kt-checkbox">
              <input type="checkbox" name="check" ${opt.selected ? 'checked' : ''}>
              <span></span>
              <div class="checkbox-text">${opt.text}</div>
            </label>`
        );
      };

      $('.quick-filters-select', $('.quick-filters'))
        .select2({ templateResult: multiCheckboxItem, dropdownCssClass: 'quick-filters-select-item pt-3' })
        .on('select2:select', quickFilterSelectHandler)
        .on('select2:unselect', quickFilterSelectHandler);
    },
    updateMultiCheckboxes: (group) => {
      const filterspage = $storage.get('filterspage_' + $page) || [];
      const filter = filterspage.find(f => f.internalName === group);

      const filterElement = $(`.quick-filters-select[data-group="${group}"]`);

      // INFO: select2 library bug work around
      // https://stackoverflow.com/questions/55910494/cannot-read-property-query-of-null-with-select2
      filterElement.select2('open');
      filterElement.val(filter?.values.map(v => v.value));

      quickFilters.initMultiCheckboxes();
    }
  };

  return {
    init,
    updateCheckBoxLists,
    updateQuickFilters,
    isInit,
    clear,
    destroy,
    setFilters,
    getFilters,
    setSorting,
    getSorting,
    cache,
    fromCache,
    prepare,
    prepareQuery
  };
})();
